import MergeLeads from './container/index';

export default MergeLeads;


// WEBPACK FOOTER //
// ./src/views/MergeLeads/index.js